export default {
  store_name: '店铺名称',
  store_url: '店铺网址',
  platform: '平台',
  seller_id: '卖家编号',
  owner_name: '店主姓名',
  store_owner_no: '店主证件号码',
  va_account: 'VA 账户',
  va_institute: 'VA 通道',
  va_status: 'VA 状态',
  review_time: '审核时间',
  close_time: '关闭时间',
  va_collection: 'VA 收款',
  va_list: 'VA 列表',
  bank_proof: '银行证明信',
  va_number: 'VA 个数',
  va_transactions: ' VA 交易查询',
  generating: '生成中',
  download_excel: '下载Excel',
  download_proof: '下载证明信压缩包',
  transaction_status: '交易状态',
  create_single_va_account: '创建单个虚拟账户',
  create_va_account: '创建虚拟账户',
  single_create_va: '创建单个VA',
  batch_create_va: '创建批量VA',
  account_details: '账户详情',
  total_number_va: '总的VA数量',
  audit_status: '审核状态',
  enter_details_create_va: '输入您的帐户详细信息以创建您的虚拟帐户',
  enter_details_create_a_va: ' 通过填写创建表格创建一个虚拟帐户',
  enter_details_create_batch_va: '通过上传excel文件批量创建虚拟账户',
  create_batch_virtual_accounts: '创建批量虚拟账户',
  batch_virtual_accounts_details: '批量生成虚拟账户步骤',
  batch_virtual_accounts_tip_1: '下载并填写创建批量虚拟账户的模板',
  va_template: 'VA 模板',
  lastest_template_tips: '最新模板：更新了创建的商店列表',
  batch_virtual_accounts_tip_2: '使用最新的VA模板上传您填写的模板文件以提交批量虚拟账户',
  download_bank_proof_zip_tip: '文件下载，需一段时间，请不要切换本系统其他页面，是否下载？'
}
